import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'statusWording'
})
export class StatusWordingPipe implements PipeTransform {

    transform(value: any, type?: string): any { // 5 | numberToArray
        switch (value) {
            case 'VAL':
                return 'Validée';
            case 'ATT':
                return 'En attente';
            case 'REF':
                return 'Refusée CE';
            case 'ANN':
                return 'Annulée';
            case 'PAY':
                return type === 'validated' ? 'Validée' : 'Payée';
            case 'FAC':
                return type === 'validated' ? 'Validée' : 'Facturée';
            case 'PAYPAR':
                return type === 'validated' ? 'Validée' : 'Payée partiel.';
            case 'ALIV':
                return 'A livrer';
            case 'LIVPAR':
                return 'Livrée partiel.';
            case 'LIV':
                return 'Livrée';
            case 'NA':
                return '';
            case 'ENC':
                return 'En cours';
            default:
                return 'Sans objet';
        }
    }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/statusWording.pipe.ts